import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useReactToPrint } from "react-to-print";
// import StockReport from "./StockReport";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const animatedComponents = makeAnimated();

const StoreRequisitionDeptAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const { qtyAmountPoints, roundOffStock } = useCustomHooks();

  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    getBranch,
  } = useContext(RestaurantContext);

  // States hook here
  const [branchDepartments, setBranchDepartments] = useState([]);
  const [departmentWiseItems, setDepartmentWiseItems] = useState([]);
  const [loadingDept, setLoadingDept] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);

  //new item
  let [newStoreRequisition, setNewStoreRequisition] = useState({
    document_no: "",
    branch: null,
    fdept: null,
    tdept: null,
    remarks: "",
  });

  //new Row
  const [newRow, setNewRow] = useState([]);
  const [rowId, setRowId] = useState(0);

  //datepicker
  const [documentDate, setDocumentDate] = useState(new Date());

  let common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  // Fetch branch-wise departments
  const getBranchWiseDepartments = async (branchId) => {
    if (!branchId) {
      setBranchDepartments([]);
      return;
    }
    setLoadingDept(true);
    const url = BASE_URL + "/settings/branch-wise-department/" + branchId;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res && res.data) {
        const depts = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : Array.isArray(res.data?.departments)
          ? res.data.departments
          : [];
        setBranchDepartments(depts);
      } else {
        setBranchDepartments([]);
      }
    } catch (error) {
      console.log("Error fetching branch departments:", error);
      setBranchDepartments([]);
    } finally {
      setLoadingDept(false);
    }
  };

  // Fetch department-wise items
  const getDepartmentWiseItems = async (foodDeptId) => {
    if (!foodDeptId) {
      setDepartmentWiseItems([]);
      return;
    }
    setLoadingItems(true);
    const url = BASE_URL + "/settings/department-wise-item/" + foodDeptId;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res && res.data) {
        const items = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];
        setDepartmentWiseItems(items);
      } else {
        setDepartmentWiseItems([]);
      }
    } catch (error) {
      console.log("Error fetching department items:", error);
      setDepartmentWiseItems([]);
    } finally {
      setLoadingItems(false);
    }
  };

  const hanldeSetEdit = (editStore) => {
    if (!editStore) return;

    const docDate = new Date(editStore.date || editStore.document_date);
    const branch =
      editStore.branch ||
      (branchForSearch &&
        branchForSearch.find((b) => b.id === editStore.branch_id)) ||
      null;

    const fdept = editStore.from_department || null;
    const tdept = editStore.to_department || null;

    setNewStoreRequisition({
      ...newStoreRequisition,
      document_no: editStore.document_identity || editStore.document_no || "",
      branch: branch,
      fdept: fdept,
      tdept: tdept,
      remarks: editStore.remarks || "",
      is_post: editStore.is_post,
    });
    setDocumentDate(docDate);

    const details =
      editStore.stock_requisitions_detail ||
      editStore.store_requisition_dept_detail ||
      [];
    if (details.length > 0) {
      const rowArr = details.map((item, index) => ({
        id: index,
        item_name: {
          ...item,
          id: item.item_id,
          name: item.item_name,
          base_unit: item.base_unit,
          conversion_qty: item.conversion_qty,
        },
        qty: roundOffStock(item.qty),
        unit: {
          id: item.unit_id,
          name: item.unit_name,
        },
        base_unit: item.base_unit,
        base_qty: item.base_qty,
        conversion_qty: item.conversion_qty,
      }));
      setRowId(details.length);
      setNewRow(rowArr);
    }
  };

  // Get Specific item for edit
  const getOpeningStockItem = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/store-requisition-dept/" + parseInt(id);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      const data = res?.data?.data || res?.data;
      if (data) {
        hanldeSetEdit(data);
        const branchId = data.branch_id || data.branch?.id;
        if (branchId) {
          getBranchWiseDepartments(branchId);
        }
        const toDeptId = data.to_dept_id || data.to_department?.id;
        if (toDeptId) {
          getDepartmentWiseItems(toDeptId);
        }
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!branchForSearch && getBranch) {
      getBranch();
    }
    if (id) {
      getOpeningStockItem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  //set items hook
  const handleSetItems = async (index, item) => {
    setNewRow((prev) => {
      const rows = [...prev];
      if (rows[index]) {
        rows[index] = {
          ...rows[index],
          item_name: item,
          unit: item?.unit ? { id: item.unit_id || item.default_unit_id, name: item.unit } : "",
          qty: "",
          base_unit: item?.base_unit || item?.unit_id,
          conversion_qty: item?.conversion_qty || 1,
        };
      }
      return rows;
    });

    if (item && item.id) {
      const url = BASE_URL + "/settings/get-unit_item/" + item.id;
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        const unitData =
          res.data && res.data.length > 0
            ? res.data[0]
            : item.unit
            ? { id: item.unit_id || item.default_unit_id, name: item.unit }
            : "";
        setNewRow((prev) => {
          const rows = [...prev];
          if (rows[index]) {
            rows[index] = {
              ...rows[index],
              unit: unitData,
              base_unit: item.base_unit || unitData?.id || unitData?.unit_id,
              conversion_qty: item.conversion_qty || unitData?.conversion_qty || 1,
            };
          }
          return rows;
        });
      } catch (error) {
        console.log("check error", error);
        if (item.unit) {
          setNewRow((prev) => {
            const rows = [...prev];
            if (rows[index]) {
              rows[index] = {
                ...rows[index],
                unit: {
                  id: item.unit_id || item.default_unit_id,
                  name: item.unit,
                },
                base_unit: item.base_unit || item.unit_id,
                conversion_qty: item.conversion_qty || 1,
              };
            }
            return rows;
          });
        }
      }
    }
  };

  const addNewRow = () => {
    if (!newStoreRequisition.branch) {
      toast.error(`${_t(t("Please select branch first"))}`, common_toast);
      return;
    }
    if (!newStoreRequisition.fdept) {
      toast.error(`${_t(t("Please select from department first"))}`, common_toast);
      return;
    }
    if (!newStoreRequisition.tdept) {
      toast.error(`${_t(t("Please select to department first"))}`, common_toast);
      return;
    }

    setNewRow((pre) => [
      ...pre,
      {
        id: rowId,
        item_name: "",
        qty: "",
        unit: "",
        item_units: "",
      },
    ]);
    setRowId((prev) => prev + 1);
  };

  const delRow = (id) => {
    setNewRow((prev) => prev.filter((item) => item.id !== id));
  };

  //set each item qty
  const handleItemQty = (index, e) => {
    const val = e.target.value;
    setNewRow((prev) => {
      const rows = [...prev];
      if (rows[index]) {
        rows[index] = {
          ...rows[index],
          qty: val,
        };
      }
      return rows;
    });
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewStoreRequisition((prev) => ({
      ...prev,
      branch: branch || null,
      fdept: null,
      tdept: null,
    }));
    setBranchDepartments([]);
    setDepartmentWiseItems([]);
    setNewRow([]);

    if (branch && branch.id) {
      getBranchWiseDepartments(branch.id);
    }
  };

  const handleSetDept = (fdept) => {
    setNewStoreRequisition((prev) => ({
      ...prev,
      fdept: fdept || null,
      tdept: null,
    }));
    setDepartmentWiseItems([]);
    setNewRow([]);
  };

  const handleSetToDept = (tdept) => {
    setNewStoreRequisition((prev) => ({
      ...prev,
      tdept: tdept || null,
    }));
    setDepartmentWiseItems([]);
    setNewRow([]);

    if (tdept && tdept.id) {
      getDepartmentWiseItems(tdept.id);
    }
  };

  const handleRemarks = (e) => {
    const value = e.target.value;
    setNewStoreRequisition((prev) => ({ ...prev, remarks: value }));
  };

  //post req of stock item add
  const storeItemAxios = async () => {
    const d = new Date(documentDate);
    const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    let slugArray = [];
    let duplicate = {};
    const duplicateItem = [];
    let hasInvalidRow = false;

    newRow.forEach((newStoreItem) => {
      if (
        !newStoreItem.item_name ||
        !newStoreItem.unit ||
        newStoreItem.qty === "" ||
        parseFloat(newStoreItem.qty) <= 0
      ) {
        hasInvalidRow = true;
      } else {
        if (duplicate[newStoreItem.item_name.id]) {
          duplicateItem.push({
            item_id: newStoreItem.item_name.id,
            item_name: newStoreItem.item_name.name,
          });
        }
        duplicate[newStoreItem.item_name.id] = true;

        const qtyNum = parseFloat(newStoreItem.qty);
        const conversion =
          parseFloat(
            newStoreItem.conversion_qty ||
              newStoreItem.item_name?.conversion_qty ||
              1
          ) || 1;
        const baseUnit =
          newStoreItem.base_unit ||
          newStoreItem.item_name?.base_unit ||
          newStoreItem.unit?.id ||
          newStoreItem.unit_id ||
          1;
        const baseQty =
          newStoreItem.base_qty !== undefined &&
          newStoreItem.base_qty !== null &&
          newStoreItem.base_qty !== ""
            ? parseFloat(newStoreItem.base_qty)
            : qtyNum * conversion;

        slugArray.push({
          qty: qtyNum,
          item_id: newStoreItem.item_name.id,
          item_name: newStoreItem.item_name.name,
          unit_id: newStoreItem.unit?.id || newStoreItem.unit_id,
          unit_name:
            newStoreItem.unit?.name ||
            newStoreItem.unit_name ||
            newStoreItem.unit,
          base_unit: baseUnit,
          base_qty: baseQty,
          conversion_qty: conversion,
        });
      }
    });

    if (duplicateItem?.length) {
      toast.error(
        `${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`,
        common_toast
      );
      return;
    }

    if (hasInvalidRow || slugArray.length === 0) {
      toast.error(
        `${_t(t("Please select all dropdowns and enter valid quantity"))}`,
        common_toast
      );
      return;
    }

    if (newRow.length === slugArray.length) {
      setLoading(true);
      let formData = {
        branch_id: newStoreRequisition.branch?.id,
        from_dept_id: newStoreRequisition.fdept.id,
        to_dept_id: newStoreRequisition.tdept.id,
        document_date: date,
        remarks: newStoreRequisition.remarks || "",
        items: slugArray,
      };

      const endPoint = id
        ? "/settings/store-requisition-dept/" + parseInt(id)
        : "/settings/store-requisition-dept";
      const url = BASE_URL + endPoint;
      const method = id ? "put" : "post";

      try {
        await axios[method](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setLoading(false);
        toast.success(
          `${_t(
            t(
              id
                ? "Store Requisition has been updated"
                : "Store Requisition has been added"
            )
          )}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        history.push("/dashboard/manage/stock/store-requisition-dept");
      } catch (error) {
        console.log("check error==>", error);
        setLoading(false);
        if (error.response?.data?.message) {
          toast.error(`${_t(t(error.response.data.message))}`, common_toast);
          return;
        }
        toast.error(`${_t(t("Please try again later"))}`, common_toast);
      }
    } else {
      toast.error(`${_t(t("Please select all dropdowns"))}`, common_toast);
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newStoreRequisition.branch !== null &&
      newStoreRequisition.fdept !== null &&
      newStoreRequisition.tdept !== null &&
      documentDate !== null
    ) {
      if (newRow.length > 0) {
        storeItemAxios();
      } else {
        toast.error(`${_t(t("Please add stocks"))}`, common_toast);
      }
    } else {
      toast.error(
        `${_t(t("Please fill all the required fields"))}`,
        common_toast
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {_t(
            t(
              newStoreRequisition?.is_post
                ? "View Store Requisition Dept"
                : id
                ? "Edit Store Requisition Dept"
                : "Add Store Requisition Dept"
            )
          )}
        </title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(
                                    t(
                                      newStoreRequisition?.is_post
                                        ? "View Store Requisition Dept"
                                        : id
                                        ? "Edit Store Requisition Dept"
                                        : "Add Store Requisition Dept"
                                    )
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              <div className="form-group col-4 mt-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="document no"
                                    className="control-label"
                                  >
                                    {_t(t("Document no"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control table-text"
                                    id="document_no"
                                    name="document_no"
                                    value={newStoreRequisition.document_no || ""}
                                    placeholder="Auto no"
                                  />
                                </div>
                              </div>

                              <div className="form-group col-4 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="transfer_date"
                                    className="control-label"
                                  >
                                    {_t(t("Document Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    selected={documentDate}
                                    onChange={(date) => setDocumentDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Document date"))}
                                    shouldCloseOnSelect={false}
                                    disabled={newStoreRequisition?.is_post}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group mt-3 col-4">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("Branch"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  components={animatedComponents}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newStoreRequisition.branch || null}
                                  isDisabled={newStoreRequisition?.is_post || id}
                                  classNamePrefix="select"
                                  onChange={handleSetBranch}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select branch")) + ".."
                                  }
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="form-group mt-2 col-4">
                                <div className="mb-1 text-left">
                                  <label
                                    htmlFor="fdept"
                                    className="control-label text-truncate"
                                  >
                                    {_t(t("From Department"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={
                                    Array.isArray(branchDepartments)
                                      ? branchDepartments
                                      : []
                                  }
                                  components={animatedComponents}
                                  getOptionLabel={(option) =>
                                    option?.name || option?.dept_name || ""
                                  }
                                  getOptionValue={(option) => option?.id || ""}
                                  value={newStoreRequisition.fdept || null}
                                  isDisabled={
                                    !newStoreRequisition.branch ||
                                    newStoreRequisition?.is_post
                                  }
                                  isLoading={loadingDept}
                                  classNamePrefix="select"
                                  onChange={handleSetDept}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    !newStoreRequisition.branch
                                      ? _t(t("Please select branch first"))
                                      : loadingDept
                                      ? _t(t("Loading..."))
                                      : _t(t("Please select dept")) + ".."
                                  }
                                  styles={customStyle}
                                />
                              </div>

                              <div className="form-group mt-2 col-4">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="tdept"
                                    className="control-label"
                                  >
                                    {_t(t("To Department"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={
                                    Array.isArray(branchDepartments)
                                      ? branchDepartments.filter(
                                          (item) =>
                                            item &&
                                            item.id !==
                                              newStoreRequisition?.fdept?.id
                                        )
                                      : []
                                  }
                                  components={animatedComponents}
                                  getOptionLabel={(option) =>
                                    option?.name || option?.dept_name || ""
                                  }
                                  getOptionValue={(option) => option?.id || ""}
                                  value={newStoreRequisition.tdept || null}
                                  classNamePrefix="select"
                                  onChange={handleSetToDept}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    !newStoreRequisition.branch
                                      ? _t(t("Please select branch first"))
                                      : !newStoreRequisition.fdept
                                      ? _t(t("Please select from dept first"))
                                      : _t(t("Please to dept")) + ".."
                                  }
                                  isDisabled={
                                    !newStoreRequisition?.branch ||
                                    !newStoreRequisition?.fdept ||
                                    newStoreRequisition?.is_post
                                  }
                                  isLoading={loadingDept}
                                />
                              </div>

                              <div className="form-group mt-2 col-4">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="remarks"
                                    className="control-label"
                                  >
                                    {_t(t("Remarks"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <textarea
                                    type="text"
                                    className="form-control table-text"
                                    id="remarks"
                                    name="remarks"
                                    onChange={handleRemarks}
                                    value={newStoreRequisition.remarks || ""}
                                    placeholder={_t(t("Remarks")) + ".."}
                                    disabled={newStoreRequisition?.is_post}
                                    style={{ height: "38px" }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              className={`table-responsive mt-3 pr-1 `}
                              style={{ maxHeight: "23rem", overflow: "auto" }}
                            >
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {newRow.length === 0 ? (
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span
                                          className="t-mr-10"
                                          onClick={() => {
                                            if (!newStoreRequisition?.is_post) {
                                              addNewRow();
                                            }
                                          }}
                                        >
                                          <i
                                            className={`fa fa-plus-circle ${
                                              !newStoreRequisition.branch ||
                                              !newStoreRequisition.fdept ||
                                              !newStoreRequisition.tdept ||
                                              newStoreRequisition?.is_post
                                                ? "cursor-not-allowed opacity-50"
                                                : "cursor-pointer"
                                            } btn-add-icon`}
                                            style={{ fontSize: "22px" }}
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </th>
                                    ) : (
                                      <th
                                        style={{
                                          borderBottomColor: "lightgray",
                                        }}
                                      ></th>
                                    )}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table_child"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Item Name"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>

                                    {/* <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Rate"))}
                                          </span>
                                        </th> */}

                                    {/* <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Amount"))}
                                          </span>
                                        </th>                                       */}

                                    {/* <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Base unit"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Base qty"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                          style={{minWidth:"9rem"}}
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Conversion unit"))}
                                          </span>
                                        </th> */}
                                    {newRow.length > 0 && (
                                      <th
                                        style={{
                                          borderBottomColor: "lightgray",
                                          minWidth: "60px",
                                        }}
                                      ></th>
                                    )}
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ? (
                                  <tbody className="align-middle">
                                    {newRow.map((item, index) => {
                                      return (
                                        <tr
                                          className="align-middle"
                                          key={index}
                                        >
                                          <td
                                            className="table-text text-capitalize align-middle text-center table-firstChild"
                                            style={{ minWidth: "60px" }}
                                          >
                                            {index === newRow.length - 1 && (
                                              <span
                                                className="t-mr-10"
                                                onClick={() => {
                                                  if (!newStoreRequisition?.is_post) {
                                                    addNewRow();
                                                  }
                                                }}
                                              >
                                                <i
                                                  className={`fa fa-plus-circle ${
                                                    !newStoreRequisition.branch ||
                                                    !newStoreRequisition.fdept ||
                                                    !newStoreRequisition.tdept ||
                                                    newStoreRequisition?.is_post
                                                      ? "cursor-not-allowed opacity-50"
                                                      : "cursor-pointer"
                                                  } btn-add-icon`}
                                                  style={{ fontSize: "22px" }}
                                                  aria-hidden="true"
                                                ></i>
                                              </span>
                                            )}
                                            &nbsp;
                                            <i
                                              className={`fa fa-minus-circle ${
                                                newStoreRequisition?.is_post
                                                  ? "cursor-not-allowed opacity-50"
                                                  : "cursor-pointer text-danger"
                                              }`}
                                              style={{ fontSize: "22px" }}
                                              onClick={() => {
                                                if (!newStoreRequisition?.is_post) {
                                                  delRow(item.id);
                                                }
                                              }}
                                            ></i>
                                          </td>
                                          <td className="table-text text-capitalize align-middle text-center">
                                            <Select
                                              options={
                                                Array.isArray(departmentWiseItems)
                                                  ? departmentWiseItems
                                                  : []
                                              }
                                              components={animatedComponents}
                                              getOptionLabel={(option) =>
                                                option?.name || ""
                                              }
                                              getOptionValue={(option) =>
                                                option?.id || ""
                                              }
                                              classNamePrefix="select"
                                              onChange={(e) =>
                                                handleSetItems(index, e)
                                              }
                                              maxMenuHeight="12.8rem"
                                              value={item.item_name}
                                              styles={customStyle}
                                              isMenuOpen={true}
                                              menuPosition="fixed"
                                              className="bank-table-input"
                                              placeholder={
                                                _t(t("Please select items")) +
                                                ".."
                                              }
                                              isLoading={loadingItems}
                                              isDisabled={newStoreRequisition?.is_post}
                                            />
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center">
                                            <input
                                              type="number"
                                              step={qtyAmountPoints()}
                                              min="0"
                                              onKeyDown={(evt) =>
                                                [
                                                  "e",
                                                  "E",
                                                  "+",
                                                  "-",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                ].includes(evt.key) &&
                                                evt.preventDefault()
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              className="form-control text-center table-Input table-text"
                                              id={item.id}
                                              name={item.id}
                                              onChange={(e) =>
                                                handleItemQty(index, e)
                                              }
                                              value={item.qty || ""}
                                              placeholder="Qty"
                                              required
                                              disabled={newStoreRequisition?.is_post}  
                                            />
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center">
                                            {item.unit?.name || (typeof item.unit === "string" ? item.unit : "")}
                                          </td>
                                          <td
                                            className="table-text text-capitalize align-middle text-center"
                                            style={{ minWidth: "60px" }}
                                          >
                                            <i
                                              className={`fa fa-minus-circle ${
                                                newStoreRequisition?.is_post
                                                  ? "cursor-not-allowed opacity-50"
                                                  : "cursor-pointer text-danger"
                                              }`}
                                              style={{ fontSize: "22px" }}
                                              onClick={() => {
                                                if (!newStoreRequisition?.is_post) {
                                                  delRow(item.id);
                                                }
                                              }}
                                            ></i>
                                            &nbsp;
                                            {index === newRow.length - 1 && (
                                              <span
                                                className="t-mr-10"
                                                onClick={() => {
                                                  if (!newStoreRequisition?.is_post) {
                                                    addNewRow();
                                                  }
                                                }}
                                              >
                                                <i
                                                  className={`fa fa-plus-circle ${
                                                    !newStoreRequisition.branch ||
                                                    !newStoreRequisition.fdept ||
                                                    !newStoreRequisition.tdept ||
                                                    newStoreRequisition?.is_post
                                                      ? "cursor-not-allowed opacity-50"
                                                      : "cursor-pointer"
                                                  } btn-add-icon`}
                                                  style={{ fontSize: "22px" }}
                                                  aria-hidden="true"
                                                ></i>
                                              </span>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                ) : null}
                                {/* {newRow && newRow.length>0 ?
                                    <tfoot className="align-middle">
                                      <tr>
                                        <th
                                          scope="col"
                                          colSpan="1"
                                          className="sm-text text-capitalize align-middle text-center border-1 border"
                                        ></th>

                                        <th
                                          scope="col"
                                          colSpan="3"
                                          className="sm-text text-capitalize align-middle text-center border-1 border"
                                        ></th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:"bold"}}>
                                              {_t(t("Total"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:"bold"}}>
                                            {formatPrice(handleAmount())}
                                          </span>
                                        </th>

                                        <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      </tr>
                                    </tfoot>
                                    :null} */}
                              </table>
                            </div>

                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/stock/store-requisition-dept"
                                    )
                                  }
                                  //   data-dismiss="modal"
                                >
                                  <i
                                    className="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading || newStoreRequisition?.is_post}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i
                                    className="fa fa-floppy-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Save"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default StoreRequisitionDeptAction;
